import {
  type CreateFollowupReasonRequest,
  type FollowupReasonDetail,
  FollowupReasonDetailSchema,
  type FollowupReasonListQuery,
  type FollowupReasonListResponse,
  FollowupReasonListResponseSchema,
  type UpdateFollowupReasonRequest,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

/**
 * FollowupReason master API. Every response is validated with the shared Zod
 * schema so a server change can't sneak past the UI types.
 */

export const listFollowupReasons = async (
  query: FollowupReasonListQuery,
): Promise<FollowupReasonListResponse> => {
  const { data } = await apiClient.get<unknown>('/followup-reasons', { params: query });
  return FollowupReasonListResponseSchema.parse(data);
};

export const getFollowupReason = async (id: string): Promise<FollowupReasonDetail> => {
  const { data } = await apiClient.get<unknown>(`/followup-reasons/${id}`);
  return FollowupReasonDetailSchema.parse(data);
};

export const createFollowupReason = async (
  payload: CreateFollowupReasonRequest,
): Promise<FollowupReasonDetail> => {
  const { data } = await apiClient.post<unknown>('/followup-reasons', payload);
  return FollowupReasonDetailSchema.parse(data);
};

export const updateFollowupReason = async (
  id: string,
  payload: UpdateFollowupReasonRequest,
): Promise<FollowupReasonDetail> => {
  const { data } = await apiClient.patch<unknown>(`/followup-reasons/${id}`, payload);
  return FollowupReasonDetailSchema.parse(data);
};

export const deleteFollowupReason = async (id: string): Promise<void> => {
  await apiClient.delete(`/followup-reasons/${id}`);
};
